export default __webpack_public_path__ + "static/media/banner-3.4d551775.png";